<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span style="display:flex;align-items:center;gap:8px">
    <mat-icon style="color:#dc2626">delete_forever</mat-icon>
    Eliminar cuenta contable
  </span>
  <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="padding:16px 24px;min-width:320px">
  <p style="font-size:14px;color:#374151;margin:0 0 8px">
    ¿Seguro que quiere eliminar esta cuenta contable?
  </p>
  <p style="font-size:13px;color:#dc2626;font-weight:500;margin:0">
    Esta acción no se puede deshacer.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button mat-flat-button color="warn" (click)="delete()">
    <mat-icon>delete</mat-icon>
    Eliminar
  </button>
</mat-dialog-actions>
